import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { JournalSectionFifth } from "./ui";

export const JournalsSectionFifthRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.section5()}`,
    element: createElement(JournalSectionFifth),
    children: [...rest],
  };
};

export const JournalsSectionFifthVersionRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.journalVersionSection5()}`,
    element: createElement(JournalSectionFifth),
    children: [...rest],
  };
};
